export function isSpacePanKey(event: Pick<KeyboardEvent, 'code' | 'key'>): boolean {
  return event.code === 'Space' || event.key === ' ' || event.key === 'Spacebar';
}

export function canStartSpacePan(
  target: EventTarget | null,
  modifiers: Pick<KeyboardEvent, 'ctrlKey' | 'metaKey' | 'altKey'> = { ctrlKey: false, metaKey: false, altKey: false },
): boolean {
  if (modifiers.ctrlKey || modifiers.metaKey || modifiers.altKey) return false;
  if (!(target instanceof HTMLElement)) return true;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return false;
  if (target.isContentEditable || target.contentEditable === 'true') return false;
  return !target.closest('.ProseMirror, [contenteditable="true"]');
}

export function applyViewportPan(
  scroller: { scrollLeft: number; scrollTop: number },
  dx: number,
  dy: number,
): { scrollLeft: number; scrollTop: number } {
  scroller.scrollLeft -= dx;
  scroller.scrollTop -= dy;
  return { scrollLeft: scroller.scrollLeft, scrollTop: scroller.scrollTop };
}
